import '@coreui/coreui'
import $ from 'jquery';
window.$ = window.jQuery = $;
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';
import 'jquery-ui/ui/widgets/datepicker.js';

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import chartjs from 'chart.js/dist/Chart.min.js';

window.moment = require('moment');
window.daterangepicker = require('daterangepicker');
window.Calendar = Calendar;
window.dayGridPlugin = dayGridPlugin;
window.timeGridPlugin = timeGridPlugin;
window.listPlugin = listPlugin;
window.interactionPlugin = interactionPlugin;
window.chartjs = chartjs;

$('.datepicker').datepicker({
    autoclose: true,
    dateFormat: 'yy/mm/dd',
    changeMonth: true,
    changeYear: true,
    locale: 'ja-jp',
});